import { render } from "./Home.vue?vue&type=template&id=59bbbe9a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=59bbbe9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59bbbe9a"

export default script